export enum SpinnerSize {
  XS = 'xs',
  S = 's',
  M = 'm',
  L = 'l',
  XL = 'xl',
}

export enum SpinnerColor {
  Primary = 'primary',
  White = 'white',
}
